/* @flow */
import Menu from 'components/Menu.jsx';
import React from 'react';

import cx from 'classnames';

import styles from './styles/NavigationMenu.css';

class NavigationMenu extends React.Component {
  render() {
    return (
      <Menu {...this.props} className={cx(styles.this, this.props.className)}>
        {this.props.children}
      </Menu>
    );
  }
}

export default NavigationMenu;



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.jsx